<template>
  <Dialog
    v-model:visible="visible"
    modal
    rtl
    dismissableMask
    :closable="false"
    :pt="{
      root: { class: '!rounded-[1.25rem] overflow-hidden' },
      header: { style: { display: 'none' } },
      content: { style: { padding: 0 } }
    }"
    :style="{ width: '90dvw', maxWidth: '440px', height: 'max-content', 'max-height': '90dvh' }"
    @hide="onHide"
  >
    <div class="relative">
      <i
        class="absolute pi pi-times bg-black bg-opacity-30 p-2 rounded-full text-white top-2 left-2 z-10 cursor-pointer hover:bg-opacity-40 transition-all"
        @click="visible = false"
      />

      <!-- Header -->
      <div class="w-full bg-gradient-to-br from-purple-100 via-purple-50 to-white pt-8 pb-4 px-6 text-center">
        <div class="w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mx-auto mb-3">
          <i class="pi pi-mobile text-2xl" />
        </div>
        <span class="inline-block text-[11px] font-medium text-primary-700 bg-primary-100 rounded-full px-2.5 py-0.5 mb-2">
          חדש · תוספת בתשלום
        </span>
        <h2 class="text-xl font-semibold text-primary-700">
          שלחו הודעות מהמספר של העסק
        </h2>
      </div>

      <div class="flex flex-col px-6 pt-3 pb-6">
        <p class="text-sm text-gray-700 leading-relaxed text-center text-pretty mb-4">
          במקום שהלקוחות יקבלו את ההודעות מהמספר של טיימאיט, הן יגיעו ישירות מהמספר שלכם.
        </p>

        <!-- Before / after sender preview -->
        <div class="w-full flex gap-2 mb-4">
          <div class="flex-1 rounded-xl border border-gray-200 bg-gray-50 p-3 text-center">
            <div class="text-[11px] text-gray-500 mb-1">היום</div>
            <div class="text-sm font-medium text-gray-500 line-through">המספר של טיימאיט</div>
          </div>
          <div class="flex items-center text-primary">
            <i class="pi pi-arrow-left" />
          </div>
          <div class="flex-1 rounded-xl border border-primary-300 bg-primary-50 p-3 text-center">
            <div class="text-[11px] text-primary-700 mb-1">עם התוספת</div>
            <div class="text-sm font-semibold text-primary-700" style="direction: ltr">
              {{ businessPhone || 'המספר שלכם' }}
            </div>
          </div>
        </div>

        <ul class="flex flex-col gap-2.5 mb-5">
          <li v-for="benefit in benefits" :key="benefit" class="flex items-start gap-2 text-sm text-gray-700">
            <i class="pi pi-check-circle text-primary mt-0.5" />
            <span>{{ benefit }}</span>
          </li>
        </ul>

        <button
          type="button"
          class="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl text-white text-sm font-medium bg-gradient-to-br from-[#8864ee] to-[#6831d0]"
          @click="contactSupport"
        >
          <i class="pi pi-whatsapp" /> אני רוצה! דברו איתי בוואטסאפ
        </button>
        <button
          type="button"
          class="w-full text-center text-sm text-gray-500 mt-3 py-1"
          @click="visible = false"
        >
          אולי בפעם אחרת
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { sendWhatsApp } from '@torim-app/utils';
import { trackEvent } from '@app/composables/posthog';
import { useAdminStore } from '@app/stores';

const props = defineProps<{ show: boolean }>();
const emit = defineEmits<{ close: [] }>();

const adminStore = useAdminStore();
const visible = ref(props.show);

const businessPhone = computed(() => adminStore.businessSiteData?.phone);

const benefits = [
  'הלקוחות מזהים אתכם מיד ופותחים את ההודעה',
  'לקוחות יכולים לחזור אליכם ישירות בשיחה או בהודעה',
  'נראה מקצועי ואישי יותר — כאילו שלחתם בעצמכם',
];

const contactSupport = () => {
  trackEvent('sms_sender_promo_whatsapp_clicked');
  sendWhatsApp('972559299380', 'היי, אשמח לשלוח את הודעות ה-SMS מהמספר של העסק שלי');
  visible.value = false;
};

const onHide = () => {
  emit('close');
};

watch(() => props.show, (show) => {
  visible.value = show;
  if (show) trackEvent('sms_sender_promo_shown');
}, { immediate: true });
</script>

